/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_4Inputs */

const en_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to <strong>Help → Offline Activation</strong>`)
};

const fr_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allez dans <strong>Aide → Activation Hors Ligne</strong>`)
};

const de_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehen Sie zu <strong>Hilfe → Offline-Aktivierung</strong>`)
};

const it_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai su <strong>Aiuto → Attivazione offline</strong>`)
};

const ru_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейдите в раздел <strong>Справка → Автономная активация</strong>`)
};

const es_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaya a <strong>Ayuda → Activación sin conexión</strong>`)
};

const zh_cn2_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往<strong>帮助 → 离线激活</strong>`)
};

const ja_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>ヘルプ → オフラインアクティベーション</strong>に移動します`)
};

const hi_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सहायता → ऑफ़लाइन सक्रियण पर जाएं`)
};

const pt_pt2_login_offline_instruction_4 = /** @type {(inputs: Login_Offline_Instruction_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesse <strong>Ajuda → Ativação offline</strong>`)
};

/**
* | output |
* | --- |
* | "Go to <strong>Help → Offline Activation</strong>" |
*
* @param {Login_Offline_Instruction_4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_4 = /** @type {((inputs?: Login_Offline_Instruction_4Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_4Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_instruction_4(inputs)
	if (locale === "de") return de_login_offline_instruction_4(inputs)
	if (locale === "it") return it_login_offline_instruction_4(inputs)
	if (locale === "ru") return ru_login_offline_instruction_4(inputs)
	if (locale === "es") return es_login_offline_instruction_4(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_instruction_4(inputs)
	if (locale === "ja") return ja_login_offline_instruction_4(inputs)
	if (locale === "hi") return hi_login_offline_instruction_4(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_instruction_4(inputs)
	return en_login_offline_instruction_4(inputs)
});